(function () {
  'use strict';

  function sanitizePrompt(prompt) {
    if (!prompt) return '';

    prompt = prompt.replace(/[\r\n]+/g, '\n');

    prompt = prompt.trim();

    return prompt;
  }

  function cleanTextForAI(text) {
    if (!text) return '';

    text = text.replace(/[^\p{L}\p{N}\s]/gu, ' ');

    text = text.replace(/\s+/g, ' ');

    return text.trim();
  }

  function extractKeywords(text, options = {}) {
    const {
      minLength = 3,
      maxWords = 10,
      stopWords = getDefaultStopWords(),
    } = options;

    const words = text
      .toLowerCase()
      .split(/\s+/)
      .filter((word) => word.length >= minLength)
      .filter((word) => !stopWords.includes(word));

    const frequencies = {};
    words.forEach((word) => {
      frequencies[word] = (frequencies[word] || 0) + 1;
    });

    return Object.entries(frequencies)
      .sort((a, b) => b[1] - a[1])
      .slice(0, maxWords)
      .map((entry) => entry[0]);
  }

  function getDefaultStopWords() {
    return [
      'the',
      'is',
      'at',
      'which',
      'on',
      'and',
      'a',
      'an',
      'as',
      'are',
      'was',
      'were',
      'been',
      'be',
      'have',
      'has',
      'had',
      'do',
      'does',
      'did',
      'will',
      'would',
      'could',
      'should',
      'may',
      'might',
      'must',
      'shall',
      'can',
      'need',
      'to',
      'of',
      'in',
      'for',
      'with',
      'it',
      'that',
      'this',
      'these',
      'those',
      'i',
      'you',
      'he',
      'she',
      'we',
      'they',
      'them',
      'their',
      'what',
      'which',
      'who',
      'when',
      'where',
      'why',
      'how',
      'all',
      'each',
      'every',
      'some',
      'any',
      'few',
      'more',
      'most',
      'other',
      'into',
      'through',
      'during',
      'before',
      'after',
      'above',
      'below',
      'from',
      'up',
      'down',
      'out',
      'off',
      'over',
      'under',
      'again',
      'further',
      'then',
      'once',
    ];
  }

  function truncateText(text, maxLength, suffix = '...') {
    if (!text || text.length <= maxLength) return text;

    const truncated = text.substring(0, maxLength - suffix.length);

    const lastSpace = truncated.lastIndexOf(' ');

    if (lastSpace > maxLength * 0.8) {
      return truncated.substring(0, lastSpace) + suffix;
    }

    return truncated + suffix;
  }

  function containsBannedPhrases(text, bannedPhrases = []) {
    const lowerText = text.toLowerCase();
    const defaultBanned = [
      'google',
      'language model',
      'openai',
      'gpt',
      'gpt-3',
      'gpt3',
      'ai language',
      'artificial intelligence',
      'trained',
      'development',
      'bard',
      'human-like',
      'feedback',
      'sorry',
      'apologize',
      'i will not',
      'under development',
      'explicit content',
      'not appropriate',
      'not capable',
      'programmed',
      'inappropriate',
      'refrain',
      'as a',
      "i don't",
    ];

    const allBanned = [...defaultBanned, ...bannedPhrases];

    return allBanned.some((phrase) => lowerText.includes(phrase));
  }

  function formatForDisplay(text, options = {}) {
    const {
      maxLength = null,
      preserveNewlines = true,
      trimWhitespace = true,
    } = options;

    if (!text) return '';

    let formatted = text;

    if (trimWhitespace) {
      formatted = formatted.trim();
    }

    if (!preserveNewlines) {
      formatted = formatted.replace(/\n+/g, ' ');
    }

    if (maxLength) {
      formatted = truncateText(formatted, maxLength);
    }

    return formatted;
  }

  function detectSentiment(text) {
    const positive = [
      'yes',
      'good',
      'great',
      'awesome',
      'excellent',
      'love',
      'happy',
      'wonderful',
    ];
    const negative = [
      'no',
      'bad',
      'terrible',
      'awful',
      'hate',
      'sad',
      'angry',
      'horrible',
    ];

    const lowerText = text.toLowerCase();
    let score = 0;

    positive.forEach((word) => {
      if (lowerText.includes(word)) score++;
    });

    negative.forEach((word) => {
      if (lowerText.includes(word)) score--;
    });

    if (score > 0) return 'positive';
    if (score < 0) return 'negative';
    return 'neutral';
  }

  window.nlpUtils = {
    sanitizePrompt,
    cleanTextForAI,
    extractKeywords,
    getDefaultStopWords,
    truncateText,
    containsBannedPhrases,
    formatForDisplay,
    detectSentiment,
  };
})();
